export const common = {
  black: '#000',
  white: '#FFF',
  transparent: 'transparnt'
};

export const red = {
  100: '#F7CCD3',
  200: '#F0A0AE',
  300: '#EA7388',
  400: '#E34762',
  500: '#D82040',
  600: '#AB1932',
  700: '#7F1225',
  800: '#520C18',
  900: '#26050B'
};

export const green = {
  100: '#CCEFE6',
  200: '#99DFCC',
  300: '#66D0B3',
  400: '#33C099',
  500: '#00B080',
  600: '#008D66',
  700: '#006A4D',
  800: '#004633',
  900: '#00231A'
};

export const blue = {
  100: '#CCE5FE',
  200: '#99CCFF',
  300: '#65B2FF',
  400: '#3299FF',
  500: '#0080FF',
  600: '#0066CC',
  700: '#004C99',
  800: '#003365',
  900: '#001932'
};

export const cyan = {
  100: '#CCFEFE',
  200: '#99FEFF',
  300: '#65FEFF',
  400: '#32FEFF',
  500: '#00FFFF',
  600: '#00CBCC',
  700: '#009899',
  800: '#006565',
  900: '#003232'
};

export const magenta = {
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c'
};

export const yellow = {
  100: '#FEFECC',
  200: '#FEFF99',
  300: '#FEFF65',
  400: '#FEFF32',
  500: '#FFFF00',
  600: '#CBCC00',
  700: '#989900',
  800: '#656500',
  900: '#323200'
};

export const gray = {
  100: '#B6CCE6',
  200: '#91B3D9',
  300: '#5079AB',
  400: '#355D8E',
  500: '#103A60',
  600: '#083050',
  700: '#082840',
  800: '#002030',
  900: '#001824'
};

export const orange = {
  100: '#FFF0E4',
  200: '#FFD4B1',
  300: '#FFB87E',
  400: '#FE9C4B',
  500: '#FF8018',
  600: '#E46600',
  700: '#B14F00',
  800: '#7E3800',
  900: '#4B2100'
};

export const salmon = {
  100: '#FFF0E4',
  200: '#FFD4B1',
  300: '#FFB87E',
  400: '#FE9C4B',
  500: '#FF6060',
  600: '#E46600',
  700: '#B14F00',
  800: '#7E3800',
  900: '#4B2100'
};

export const turquoise = {
  100: '#CCF2FE',
  200: '#99E5FF',
  300: '#65D9FF',
  400: '#32CCFF',
  500: '#00C0FF',
  600: '#0099CC',
  700: '#007399',
  800: '#004C65',
  900: '#002632'
};

export const purple = {
  100: '#DFD7FF',
  200: '#BFAFFF',
  300: '#A088FF',
  400: '#8060FF',
  500: '#6038FF',
  600: '#4D2DCC',
  700: '#3A2299',
  800: '#261666',
  900: '#130B33'
};
